import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';


@Component({
  selector: 'rr-step',
  standalone: false,

  templateUrl: './step.component.html',
  styleUrl: './step.component.scss'
})
export class StepComponent {
  @Input() label: string | undefined;

  currentStep?: number;
  step?: number;
}
